<p-overlay
  [appendTo]="button"
  target="@parent"
  [visible]="visible"
  direction="bottom-start"
  styleClass="favourites-overlay pointer-events-none"
  contentStyleClass="bg-surface-0 dark:bg-surface-900 shadow rounded-border overflow-hidden"
  (onHide)="hideOverlay()"
  [autoZIndex]="true"
  [baseZIndex]="6000"
  role="menu">
  <ng-template pTemplate="content"
    ><div *ngFor="let item of menuItems; let i = index" role="menuitem" [title]="item.label | translate">
      <div
        class="flex items-center justify-between border-b border-gray-300 bg-gray-100 px-4 py-2"
        [ngClass]="{
          'border-t': i !== 0
        }">
        <span class="mr-4 text-left text-base leading-normal font-medium text-gray-800">{{
          item.label | translate
        }}</span>
        <a
          (click)="navigateToSuiteView(item.url)"
          role="link"
          class="pointer-events-auto flex items-center text-left text-sm leading-tight font-medium whitespace-nowrap text-blue-400 no-underline hover:text-blue-600!"
          ><i class="fa-solid fa-star pointer-events-auto mr-1 text-blue-400"></i>{{ 'favourites.all' | translate }}</a
        >
      </div>
      <a
        *ngFor="let el of item.items"
        (click)="navigateToSuiteView(el.url)"
        role="link"
        class="pointer-events-auto flex bg-white px-4 py-2 text-left text-sm leading-tight font-medium text-gray-700 no-underline hover:bg-gray-200">
        {{ el.label | translate }}
      </a>
    </div>
    <a
      (click)="navigateToSuiteView('objecttypes')"
      class="pointer-events-auto flex items-center border-t border-gray-300 bg-gray-100 px-4 py-2 text-left text-sm leading-tight font-medium text-blue-400 no-underline hover:text-blue-600"
      ><i class="fa-solid fa-rectangle-list mr-1 text-blue-400"></i>{{ 'forms.all' | translate }}</a
    >
  </ng-template>
</p-overlay>
